module.exports = __webpack_public_path__ + "img/clothing128.374d9eb3.jpg";